import BaseFormWrapperLayout from "./BaseFormWrapperLayout.vue";

export default BaseFormWrapperLayout;
